// extracted by mini-css-extract-plugin
module.exports = {"list":"Sortable_list__2yndY","item":"Sortable_item__3Ddfw","load":"Sortable_load__awzTa"};